import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Smartphone, X } from "lucide-react";

const STORAGE_KEY = "tch_app_ribbon_dismissed";

const readDismissed = () => {
  if (typeof window === "undefined") return false;
  try { return localStorage.getItem(STORAGE_KEY) === "1"; }
  catch { return false; }
};

/**
 * Mobile-only "Get the app" ribbon.
 *
 * Renders above the sticky header for narrow viewports. Hidden on md+ so
 * desktop visitors never see it. Dismissal is persisted in localStorage —
 * non-sensitive UI flag, same pattern as the cookie banner and splash flag.
 */
export const GetAppRibbon = () => {
  const [dismissed, setDismissed] = useState(readDismissed);

  if (dismissed) return null;

  const dismiss = () => {
    setDismissed(true);
    try { localStorage.setItem(STORAGE_KEY, "1"); }
    catch { /* ignore quota errors — banner just reappears next session */ }
  };

  return (
    <div
      className="md:hidden bg-gray-900 text-white text-xs px-3 py-2 flex items-center gap-2 border-b-2 border-[#FFD93D]"
      data-testid="get-app-ribbon"
      role="region"
      aria-label="Mobile app promotion"
    >
      <Smartphone className="w-4 h-4 flex-shrink-0 text-[#FFD93D]" />
      <span className="flex-1 truncate">
        ToyCycleHub is now on your phone — try the mobile beta.
      </span>
      <Link
        to="/get-the-app"
        className="font-black uppercase text-[10px] bg-[#FFD93D] text-gray-900 px-2.5 py-1 rounded-full border-2 border-gray-900 hover:bg-white transition-colors"
        data-testid="get-app-ribbon-cta"
      >
        Get it
      </Link>
      <button
        type="button"
        onClick={dismiss}
        aria-label="Dismiss mobile app ribbon"
        className="p-1 text-white/70 hover:text-white flex-shrink-0"
        data-testid="get-app-ribbon-dismiss"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default GetAppRibbon;
